let env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'localhost', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );

if ( env === 'localhost' ) {
    env = 'qa';
}

export const currentEnv = env;

export function getEnv() {
	return env ? env : '';
}

function getURL( url ) {
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const idURL = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const idTestAppUrl = 'http://localhost:9090';
export const kadhavuExpUrl = getURL( 'https://(env.)api.biw.cloud/v1/kadhavu-exp-api/api/v1' );
export const cashierUrl = getURL( 'https://(env.)api.biw.cloud/v1/cashier' );
export const piersUrl = getURL( 'https://(env.)api.biw.cloud/v1/piers/graphql' );
